import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const meditationSteps = [
  {
    number: 1,
    title: 'Sit Comfortably',
    description: 'Find a comfortable seated position and relax your shoulders. Allow your body to settle naturally.'
  },
  {
    number: 2,
    title: 'Deep Breathing',
    description: 'Take slow, deep breaths. Inhale through your nose and exhale slowly through your mouth.'
  },
  {
    number: 3,
    title: 'Release Tension',
    description: 'With each exhale, consciously let go of any tension you feel in your body and mind.'
  },
  {
    number: 4,
    title: 'Present Moment Awareness',
    description: 'Focus on being fully present. Notice your breath, your body, and the sensations around you.'
  }
];

const MorningMeditationSession2: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Morning Meditation Session 2',
      description: 'Completed Morning Meditation Session 2.',
      image: require('../assets/meditation.png').default || require('../assets/meditation.png'),
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(session)
      });
    } catch (err) {

    }
    navigate('/panel/dashboard/morning-meditation');
  };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 2: 10-Minute Morning Meditation</h1>
              <p className="session-description">
                Follow along with the guided meditation and use the instructions on the right for additional guidance. Take your time and breathe deeply.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/cyMxWXlX9sU?si=WoN3TxiODFMNdbjF"
                  title="Session 2: Guided Morning Meditation"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Meditate</h2>
                <div className="session-steps">
                  {meditationSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MorningMeditationSession2;

